export const EMBLEMS = {
  miners: `
<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="minersBg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#3a2516"/>
      <stop offset="1" stop-color="#1a0f07"/>
    </linearGradient>
  </defs>
  <polygon points="32,2 60,16 60,48 32,62 4,48 4,16" fill="url(#minersBg)" stroke="#ffb548" stroke-width="2"/>
  <polygon points="32,2 60,16 60,48 32,62 4,48 4,16" fill="none" stroke="#ffe3a0" stroke-width="0.8" opacity="0.6"/>
  <g stroke="#ffb548" stroke-width="2.2" stroke-linecap="round" fill="none">
    <path d="M20 42 L32 22 L44 42"/>
    <path d="M26 42 L32 30 L38 42"/>
  </g>
  <circle cx="32" cy="20" r="3.2" fill="#ffe3a0"/>
  <g fill="#ffb548">
    <rect x="14" y="46" width="4" height="8"/>
    <rect x="46" y="46" width="4" height="8"/>
  </g>
</svg>`,
  pirates: `
<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="piratesBg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#2a0a14"/>
      <stop offset="1" stop-color="#10040a"/>
    </linearGradient>
  </defs>
  <polygon points="32,2 60,16 60,48 32,62 4,48 4,16" fill="url(#piratesBg)" stroke="#ff5a6a" stroke-width="2"/>
  <polygon points="32,2 60,16 60,48 32,62 4,48 4,16" fill="none" stroke="#ffd0d6" stroke-width="0.8" opacity="0.5"/>
  <g fill="#ffe3e6" stroke="#2a0a14" stroke-width="0.6">
    <path d="M32 18 C24 18 20 24 20 30 C20 34 22 37 24 38 L24 42 L28 42 L28 40 L30 40 L30 42 L34 42 L34 40 L36 40 L36 42 L40 42 L40 38 C42 37 44 34 44 30 C44 24 40 18 32 18 Z"/>
    <circle cx="27" cy="29" r="2.6" fill="#2a0a14"/>
    <circle cx="37" cy="29" r="2.6" fill="#2a0a14"/>
  </g>
  <g stroke="#ff5a6a" stroke-width="2.6" stroke-linecap="round">
    <line x1="14" y1="46" x2="50" y2="52"/>
    <line x1="14" y1="52" x2="50" y2="46"/>
  </g>
</svg>`,
  guards: `
<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="guardsBg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#0c1e3a"/>
      <stop offset="1" stop-color="#04091a"/>
    </linearGradient>
  </defs>
  <path d="M32 3 L58 12 L56 38 C54 48 44 56 32 61 C20 56 10 48 8 38 L6 12 Z"
        fill="url(#guardsBg)" stroke="#6ac0ff" stroke-width="2"/>
  <path d="M32 3 L58 12 L56 38 C54 48 44 56 32 61 C20 56 10 48 8 38 L6 12 Z"
        fill="none" stroke="#d5ecff" stroke-width="0.8" opacity="0.55"/>
  <g fill="#6ac0ff">
    <polygon points="32,14 40,26 36,26 36,40 28,40 28,26 24,26"/>
  </g>
  <g stroke="#d5ecff" stroke-width="1.6" stroke-linecap="round" fill="none" opacity="0.85">
    <path d="M18 44 L32 50 L46 44"/>
  </g>
  <circle cx="32" cy="20" r="2.2" fill="#ffffff"/>
</svg>`
} as const;
